import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["srcset", "sizes"]
const _hoisted_2 = ["srcset", "sizes"]
const _hoisted_3 = ["src", "srcset", "sizes", "alt"]

import { computed, ref } from "vue";
import { getClasses } from "~/js/composables/classes";
import { Image } from "~/js/interfaces/media";

interface Props {
	image: Image;
	ratio?: string;
	sizes?: Array<string>;
	utilities?: string;
	imageUtilities?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageTeaser',
  props: {
    image: {},
    ratio: { default: "aspect-4/3" },
    sizes: {},
    utilities: { default: "" },
    imageUtilities: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const classes = ref({
	image: {
		object: "object-cover object-center",
		size: "w-full h-full",
	},
});

const sizes = computed(() => {
	if (props.sizes) {
		return props.sizes.join(",");
	}

	return "100vw";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("figure", {
    class: _normalizeClass([__props.utilities, __props.ratio])
  }, [
    _createElementVNode("picture", null, [
      _createElementVNode("source", {
        srcset: __props.image.srcsetWebp,
        sizes: sizes.value,
        type: "image/webp"
      }, null, 8, _hoisted_1),
      _createElementVNode("source", {
        srcset: __props.image.srcset,
        sizes: sizes.value
      }, null, 8, _hoisted_2),
      _createElementVNode("img", {
        src: __props.image.placeholder,
        srcset: __props.image.srcset,
        sizes: sizes.value,
        class: _normalizeClass([_unref(getClasses)(classes.value, 'image'), __props.imageUtilities].filter(Boolean)),
        alt: __props.image.alt,
        loading: "lazy"
      }, null, 10, _hoisted_3)
    ])
  ], 2))
}
}

})